import type { DisplayCue } from "@expert/contentful";
import { useProductInfo } from "@expert/contentful";
import type { Partner } from "@expert/shared-types";
import { userCache } from "@/shared-utils";

export const useDisplayCues = (partner: Partner): { displayCues: DisplayCue[]; isLoading: boolean } => {
    const { displayCues, isLoading } = useProductInfo(partner, userCache.employeeId);

    return { displayCues, isLoading };
};
